// extracted by mini-css-extract-plugin
export default {"container":"demo-phone_container__3klJU","phone":"demo-phone_phone__t1cF1","app":"demo-phone_app__UWR8a"};